export enum Disposition {
	Burial = 'burial',
	Cremation = 'cremation',
}
